const Vehcile = {
  validHeader: {
    'Vehicle Name': 'short_form',
    CFT: 'cft',
    KG: 'kg',
    'Vehicle Type': 'vehicle_type',
    'Fuel Type': 'fuel_type',
  },
  optionalHeader: {
    'Length (cm)': 'length',
    'Breadth (cm)': 'breadth',
    'Height (cm)': 'height',
    Description: 'description',
    'Utilization Check Category': 'utilisation_check_category',
    Mode: 'mode',
    'Seal Available': 'seal_available',
    'Carbon Emission Factor' : 'carbon_emission_factor',
    'Exclude Material Category': 'exclude_sku_categories',
  },
};
const vahanSarathi = {
  VEHICLE_NOT_FOUND: 'Vehicle details not found in response',
  DL_NOT_VALID: 'Driving License validity is less than EDD',
  DRIVER_NOT_ELIGIBLE: 'Driver is not eligible for the current vehicle category',
  VAHAN_SARATHI_BEARER_TOKEN: 'Vahan Sarathi Bearer Token',
  VAHAN_PROCESSING: 'Vahan Processing',
  VAHAN_DOWN: 'Vahan System is down. No validation can be done at this moment',
  VAHAN_COMPLETED: 'Vahan Completed',
  VAHAN_FAILED: 'Vahan Failed',
  SARATHI_PROCESSING: 'Sarathi Processing',
  SARATHI_DOWN: 'Sarathi System is down. No validation can be done at this moment',
  SARATHI_COMPLETED: 'Sarathi Completed',
  SARATHI_FAILED: 'Sarathi Failed',
  BOTH_COMPLETED: 'Vahan and Sarathi both Completed',
  BOTH_PROCESSING: 'Both Processing',
  BOTH_FAILED:'Both Failed',
  STATUS_PROCESSING:'Processing',
  STATUS_BOTH_COMPLETED:'Both Completed',
  STATUS_COMPLETED:'Completed',
  STATUS_FAILED:'Failed',
  STATUS_RETURN_COMPLETED:'completed',
  STATUS_RETURN_FAILED:'failed',
  STATUS_RETURN_PROCESSING:'processing',
  VAHAN_VERIFICATION:'Vahan Verification',
  SARATHI_VERIFICATION:'Sarathi Verification',
  VAHAN_SARATHI_VERIFICATION:'Vahan & Sarathi Verification',
  TRANSACTION_ERR: "Transaction ID is required",
  NO_VALIDATION_SARATHI: 'No validation has been applied for sarathi',
  NO_VALIDATION_VAHAN: 'No validation has been applied for vahan',
  VAHAN_SARATHI_INTEGRATION: 'VAHAN SARATHI INTEGRATION',
  VAHAN_INTEGRATION: 'VAHAN INTEGRATION',
  SARATHI_INTEGRATION: 'SARATHI INTEGRATION',
};

module.exports = { Vehcile, vahanSarathi };
